/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Swap product grid images on mobile: show lifestyle image (image 2) before product image (image 1)
  function swapMobileImages() {
    if (window.innerWidth > 768) return;
    
    document.querySelectorAll('.product-item__bg__slider').forEach(function(slider) {
      if (slider.dataset.mobileSwapped) return; // Don't swap twice
      var slides = slider.querySelectorAll('.product-item__bg__slide');
      if (slides.length >= 2) {
        slider.appendChild(slides[0]);
        slider.dataset.mobileSwapped = 'true';
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapMobileImages);
  } else {
    swapMobileImages();
  }
  
  var grid = document.querySelector('.collection__products, .grid');
  if (grid) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) swapMobileImages();
      });
    }).observe(grid, { childList: true, subtree: true });
  }
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
